import React, { useCallback } from 'react';
import {
  ActiveTag,
  Content,
  Data,
  Description,
  Group,
  Header,
  Image,
  LeftSection,
  PersonalHeader,
  PersonalText,
  SectionWrapper,
  TagDiv,
  Title
} from './styles';
import AppLayout from '../../../component/appLayout';
import ResponsiveHeader from '../../../component/responsiveHeader/header';
import { useMobileDevice } from '../../../global/useMobile';
import BottomSubNavigation from '../../../component/bottomNavigation/subNavigation';
import ButtonV2 from '../../../component/button/buttonV2';
import { useHistory } from 'react-router-dom';
import { rootStore } from '../../../mobx/rootStore';
import { useDispatch } from 'react-redux';
import { activateAgent, deactivateAgent } from '../../../services/workspaceService';
import { observer } from 'mobx-react-lite';
import { BUTTON_TYPE } from '../../../global/constants';

const AIAgents = () => {
  //Mobx store
  const { workspaceStore } = rootStore;
  const { currentWorkspace } = workspaceStore;

  // other variables
  const isMobile = useMobileDevice();
  const history = useHistory();
  const dispatch = useDispatch();

  const onClickCard = useCallback(
    (agentId: string) => {
      history.push(`/settings/ai-agents/details/${agentId}`);
    },
    [history]
  );

  const handleActivateAgent = useCallback(
    async (e: React.SyntheticEvent, agentId: string, isActive: boolean) => {
      e.stopPropagation();
      if (isActive) {
        await dispatch(deactivateAgent(agentId));
        currentWorkspace?.disableAgent(agentId);
      } else {
        await dispatch(activateAgent(agentId));
        currentWorkspace?.enableAgent(agentId);
      }
    },
    [currentWorkspace, dispatch]
  );

  return (
    <>
      <AppLayout>
        <Group>
          {isMobile ? (
            <ResponsiveHeader Title='AI Agents' />
          ) : (
            <Header>
              <PersonalHeader>
                <PersonalText>AI Agents</PersonalText>
              </PersonalHeader>
            </Header>
          )}
          <Content>
            {currentWorkspace?.aiAgents?.map((agent) => {
              return (
                <Data onClick={() => onClickCard(agent.id)}>
                  <LeftSection>
                    <Image src={agent.profile_photo} alt='ai-agent' width={32} height={32} />
                    <SectionWrapper>
                      <Title>{agent.name}</Title>
                      <Description>{agent.description}</Description>
                    </SectionWrapper>
                  </LeftSection>
                  {!agent.isActive ? (
                    <ButtonV2
                      title='Activate'
                      variant={BUTTON_TYPE.SECONDARY}
                      buttonType='button'
                      size='small'
                      onClick={(e: React.SyntheticEvent) => handleActivateAgent(e, agent.id, agent.isActive)}
                    />
                  ) : (
                    <TagDiv>
                      <ActiveTag
                        onClick={(e) => handleActivateAgent(e, agent.id, agent.isActive)}
                        className='active-tag'>
                        Active
                      </ActiveTag>
                      <ButtonV2
                        title='Deactivate'
                        buttonType='button'
                        size='small'
                        variant={BUTTON_TYPE.SECONDARY}
                        onClick={(e: React.SyntheticEvent) => handleActivateAgent(e, agent.id, agent.isActive)}
                        className='deactivate-button'
                      />
                    </TagDiv>
                  )}
                </Data>
              );
            })}
          </Content>
        </Group>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
};

export default observer(AIAgents);
